<div id="openExtendsTransfers" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content" *ngIf="book != null">
      <div class="modal-header">
        <h5 class="modal-title mt-0" id="mySmallModalLabel">Traspasar programa | <span class="f-s-13">Origen reserva: <span class="bold">{{tour.booking_data.code}}</span></span></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <app-loading-modal></app-loading-modal>
      <ng-container *ngIf="book != null">
        <form validate [formGroup]="item" (ngSubmit)="preSave()" autocomplete="off">
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-6">
                <div class="row">
                  <div class="form-group col-lg-12">
                    <label>Agencia operadora<span class="required"></span>
                      <ng-container *ngIf="agencySelected != null">
                        <span class="m-l-15 bold"><i class="fas fa-phone m-r-5"></i>{{agencySelected.cellphone}}</span>
                      </ng-container>
                    </label>
                    <ng-container *ngIf="agencySelected != null">
                      <div class="input-group">
                        <input type="text" class="form-control form-control-sm" disabled
                          value="{{agencySelected.tradename}}-{{agencySelected.document_str}}">
                        <div class="input-group-append bg-custom b-0 removeClient">
                          <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                            uib-tooltip="Quitar" (click)="removeAgencies()">
                            <i class="fas fa-backspace w-100 f-s-12"></i>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="agencySelected == null">
                      <component-search-agencies [classSize]="'search-small'"
                        (selectedAgenciesEvent)="selectedAgenciesSearch($event)" class="w-100">
                      </component-search-agencies>
                    </ng-container>
                  </div>
                  <ng-container *ngIf="agencySelected != null">
                    <ng-container *ngIf="agencySelected.id == tour.booking_data.agency_id">
                      <div class="form-group col-lg-12">
                        <span class="badge badge-warning f-s-11"><strong>Cuidado!,</strong> la agencia seleccionada es la misma que la de origen recibido</span>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
              <div class="form-group col-lg-4">
                <label>
                  Nombre tour
                </label>
                <span>{{tour.description}}</span>
              </div>
              <div class="form-group col-lg-2">
                <label>
                  N° PAX
                </label>
                <span>{{tour.quantity}}</span>
              </div>
              <div class="form-group col-lg-2">
                <label>
                  Vehículo
                </label>
                <span
                  class="badge f-s-10 badge-{{tour.vehicle_tour_content.class}}">{{tour.vehicle_tour_content.description}}</span>
              </div>
              <div class="form-group col-lg-2">
                <label>
                  Turno
                </label>
                <span>{{tour.shift_tour_content.description}}</span>
              </div>
              <div class="form-group col-lg-2">
                <label>
                  F.asignada
                </label>
                <span>{{tour.date_assigned | date: 'mediumDate'}}</span>
              </div>
              <div class="form-group col-lg-3">
                <label>
                  Precio Corporativo
                </label>
                <div class="input-group">
                  <span class="input-group-prepend"><span class="input-group-text"
                      style="padding: 2px 9px;">S/</span></span>
                  <input type="text" id="tours_pricecorporate" value="{{tour.price_corporate}}" numeric decimals="2"
                    (keyup)="changePriceCorporate($event.target)" onclick="click_input(this)"
                    class="form-control sale__input text-right">
                </div>
              </div>
              <div class="form-group col-lg-3">
                <label>
                  Cobranza delegada
                </label>
                <div class="input-group">
                  <span class="input-group-prepend"><span class="input-group-text"
                      style="padding: 2px 9px;">S/</span></span>
                  <input type="text" id="tours_delegatedpayment" value="{{tour.delegated_payment}}" numeric decimals="2"
                    (keyup)="changeDelegatedPayment($event.target)" onclick="click_input(this)"
                    class="form-control sale__input text-right">
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer nowrap">
            <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal"
              (click)="close()">Cancelar</button>
            <button type="submit" class="btn btn-primary"><i class="far fa-save m-r-5"></i>GUARDAR TRASPASO</button>
          </div>
        </form>
      </ng-container>
    </div>
  </div>
</div>

